import { render } from "./EditAlbum.vue?vue&type=template&id=57714afe"
import script from "./EditAlbum.vue?vue&type=script&lang=js"
export * from "./EditAlbum.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__